export enum FIREBASE_COLLECTIONS {
  ORDERS = 'orders',
  EXPIRED_ORDERS = 'expiredOrders',
  PREFERENCES = 'preferences',
  ORDER_AND_SUBS_UPDATES = 'orderAndSubsUpdates',
  SIGNUP_STEPS = 'signupSteps'
}

export enum LOCALSTORAGE_KEYS {
  CART = 'cart',
  ORDER = 'order',
  SESSION = 'session',
  ANONYMOUS_ADDRESS = 'anonymousAddress',
  SELECTED_CATEGORY = 'selectedCategory',
  NEW_ACCOUNT = 'newAccount',
  GOOGLEPLACERESULT = 'googlePlaceObject',
  MARKETING_REFERRAL = 'marketingReferral',
  FIRST_LOGIN = 'firstLogin',
  SIGNUP_CUSTOM_BOX = 'signupCustomBox',
  SELECTED_DELIVERY_PREFERENCE = 'selectedDeliveryPreference',
  SELECTED_PICKUP_OPTION = 'selectedPickUpOption',
  ROUTE_TO_NAVIGATE_AFTER_LOGIN = 'routeToNavigateAfterLogin',
  FROM_LOGIN = 'fromLogin',
  PERMISSIONS = 'permissions',
  MAINTENANCE_MODE = 'maintenanceMode',
  MAINTENANCE_SCHEDULED = 'maintenanceScheduled',
  MAINTENANCE_TITLE = 'maintenanceTitle',
  MAINTENANCE_MESSAGE = 'maintenanceMessage',
  NO_PASSWORD_USER_EMAIL = 'noPasswordUserEmail',
  PRELOADED_EMAIL = 'preloadedEmail',
  PROMOTION_INFO = 'promotionInfo',
  SIGNUP_FUNNEL_STEPS_COMPLETED = 'signupFunnelStepsCompleted'
}
